import * as React from 'react';
import { Dispatch, connect } from 'react-redux';
import { IApplicationState, AppActionCreators, ITicketingState, TicketingActionCreators, ITicketLookupDataResponse, ICannedResponseListResponse } from '@nkr/store/index';
import { IBaseResponse, ITicketCannedResponse, IUser } from '@nkr/models/index';
import { CannedResponseAvailability } from '@nkr/enums/index';
import { Table, Button, DropdownButton, MenuItem, Modal, OverlayTrigger, Popover } from 'react-bootstrap';
import styled from 'styled-components';
import { toast } from 'react-toastify';
import ReactHtmlParser from 'react-html-parser';
import { PopoverWrapper } from '@nkr/views/admin/center/list/saturation-grid/overlays';

const TableWrapper = styled(Table)`
    tbody > tr > td {
        vertical-align: middle;
    }
`;

interface IProps { }

interface IStateProps {
    ticketing: ITicketingState,
    user: IUser
}

interface IDispatchProps {
    showLoading: (message: string) => Promise<void>,
    hideLoading: () => void,
    getCannedResponses: () => Promise<ICannedResponseListResponse>,
    getLookupData: () => Promise<ITicketLookupDataResponse>,
    deleteCannedResponse: (id: number) => Promise<IBaseResponse>
}

type TProps = IProps & IStateProps & IDispatchProps;

interface IState {
    delete: {
        show: boolean,
        data: ITicketCannedResponse
    }
}

class TicketCannedResponseList extends React.Component<TProps, IState> {
    readonly state: IState = {
        delete: {
            show: false,
            data: null
        }
    }

    componentDidMount = () => {
        this.getData();
    }

    getData = () => {
        this.props.showLoading('Loading canned responses, one moment please...').then(() => {
            return Promise.all([
                this.props.getCannedResponses(),
                this.props.getLookupData()
            ]).then((response: [ICannedResponseListResponse, ITicketLookupDataResponse]) => {
                this.props.hideLoading();
            });
        });
    }

    getOverlay = (message: string) => {
        return (
            <PopoverWrapper bsSize='lg' style={{ whiteSpace: 'normal', wordBreak: 'break-all', wordWrap: 'break-word' }}>
                {ReactHtmlParser(message)}
            </PopoverWrapper>
        );
    }

    handleConfirmDelete = (id: number) => {
        let data = this.props.ticketing.cannedResponses.find(x => x.id == id);

        this.setState({
            delete: {
                show: true,
                data
            }
        });
    }

    handleDelete = () => {
        this.props.showLoading('Deleting canned response, one moment please...').then(() => {
            this.props.deleteCannedResponse(this.state.delete.data.id).then(response => {
                this.props.hideLoading();

                if (response.data.success) {
                    this.setState({
                        delete: {
                            show: false,
                            data: null
                        }
                    }, () => {
                        toast.success('Canned response deleted successfully', {
                            onClose: () => {
                                this.getData();
                            }
                        });
                    });
                }
            });
        });
    }

    handleCancelDelete = () => {
        this.setState({
            delete: { ...this.state.delete, show: false }
        });
    }

    render = () => {
        const deleteName = this.state.delete.data ? this.state.delete.data.title : '';

        return (
            <>
                <div className='container'>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <h1 style={{ marginTop: 0, marginBottom: 20 }}>Canned Responses</h1>
                        <div>
                            <Button bsStyle='link' onClick={() => window.location.href = '/ticketing/canned-response/new'}>New Canned Response</Button>
                        </div>
                    </div>

                    <TableWrapper condensed striped>
                        <thead>
                            <tr>
                                <th>Response</th>
                                <th style={{ width: 130 }}>Owner</th>
                                <th style={{ width: 100 }}>Availability</th>
                                <th style={{ width: '5%' }}></th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.props.ticketing.cannedResponses.map((response, index) =>
                                <tr key={index}>
                                    <td>
                                        <OverlayTrigger placement='right' trigger={['hover', 'focus']} overlay={this.getOverlay(response.message)}>
                                            <span>{response.title}</span>
                                        </OverlayTrigger>
                                    </td>
                                    <td>{response.ownerName}</td>
                                    <td>
                                        {response.availability == CannedResponseAvailability.Myself && (
                                            <>Myself</>
                                        )}

                                        {response.availability == CannedResponseAvailability.AllAgents && (
                                            <>All Agents</>
                                        )}
                                    </td>
                                    <td>
                                        <DropdownButton bsStyle='primary' title='Action' id={'action-' + response.id}>
                                            <MenuItem onClick={() => window.location.href = `/ticketing/canned-response/${response.id}`}>Edit</MenuItem>
                                            <MenuItem onClick={() => this.handleConfirmDelete(response.id)}>Delete</MenuItem>
                                        </DropdownButton>
                                    </td>
                                </tr>
                            )}

                            {this.props.ticketing.cannedResponses.length == 0 && (
                                <tr>
                                    <td>
                                        You haven't created any canned responses. <a href='/ticketing/canned-response/new'>Create New</a>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </TableWrapper>
                </div>

                <Modal show={this.state.delete.show} onHide={this.handleCancelDelete}>
                    {/* <Modal.Header>Delete Canned Response?</Modal.Header> */}
                    <Modal.Body>
                        <div className='text-center' style={{ marginBottom: 20 }}>Are you sure you want to delete the following canned response?</div>
                        <div className='text-center text-lg' style={{ marginBottom: 20 }}><strong>{deleteName}</strong></div>

                        {/* <div className='text-right'>
                            <Button style={{ width: 100, marginRight: 10 }}>Delete</Button>
                            <Button bsStyle='primary' style={{ width: 100 }} onClick={this.handleCancelDelete}>Cancel</Button>
                        </div> */}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={this.handleDelete}>Delete</Button>
                        <Button bsStyle='primary' onClick={this.handleCancelDelete}>Cancel</Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        ticketing: state.ticketing,
        user: state.app.user
    };
}

const mapDispatchToProps = (dispatch: Dispatch<any>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            return dispatch(AppActionCreators.hideLoading());
        },
        getCannedResponses: () => {
            return dispatch(TicketingActionCreators.getCannedResponses());
        },
        getLookupData: () => {
            return dispatch(TicketingActionCreators.getLookupData());
        },
        deleteCannedResponse: (id) => {
            return dispatch(TicketingActionCreators.deleteCannedResponse(id));
        }
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(TicketCannedResponseList);